import React from 'react';

import { IIconProps } from '@icons/IIconProps';
import { EuroCircleIcon } from '@icons/index';

const EuroFilledIcon = (props: IIconProps) => {
    return <EuroCircleIcon style={{ color: '#6a329f', fontSize: 28, ...props.style }} />;
};

export default EuroFilledIcon;
